import React from 'react';
import { Segment } from 'tea-component';
import {
  sentimentOptions,
  topicTierOptions,
  topicTypeOptions,
} from '../../constants';
import './index.scss';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import useLanguage from '@op/hooks/useLanguage';
import BubbleCommon, {
  summaryCommonSentimentTips,
  summaryTopicSentimentTips,
} from '@op/components/BubbleCommon';

export default function TopSelectFilter({
  sentiment,
  setSentiment,
  topicType,
  setTopicType,
  topicLevel,
  setTopicLevel,
  isTopicSentiment,
  setIsTopicSentiment,
}: {
  sentiment: string;
  setSentiment: any;
  topicType: string;
  setTopicType: any;
  topicLevel: string;
  setTopicLevel: any;
  isTopicSentiment: string;
  setIsTopicSentiment: any;
}) {
  const { formatMessage } = useLanguage();

  return (
    <div className="dbo-top-change-select">
      <Segment
        value={topicType}
        className="segment-light"
        onChange={(value) => {
          buriedBtnPoint('STO_AllKeyTAB', value);
          setTopicType(value);
        }}
        options={topicTypeOptions.map(({ text, value, tips }) => {
          return {
            text: (
              <BubbleCommon placement="top" showIcon={false} tipsMap={tips}>
                <span>{formatMessage({ id: text })}</span>
              </BubbleCommon>
            ),
            value: value,
          };
        })}
      />
      <Segment
        value={topicLevel}
        className="segment-light"
        onChange={(value) => {
          buriedBtnPoint('STO_tierTopic', value);
          setTopicLevel(value);
        }}
        options={topicTierOptions(formatMessage)}
      />
      <Segment
        value={sentiment}
        className="segment-light"
        onChange={(value) => {
          buriedBtnPoint('STO_sentiment', value);
          setSentiment(value);
        }}
        options={sentimentOptions(formatMessage)}
      />
      <Segment
        value={isTopicSentiment}
        className="segment-light"
        onChange={(value) => {
          // buriedBtnPoint('STO_sentiment', value);
          setIsTopicSentiment(value);
        }}
        options={[
          {
            text: (
              <BubbleCommon
                showIcon={false}
                tipsMap={summaryCommonSentimentTips}
              >
                {formatMessage({ id: 'Sentiment' })}
              </BubbleCommon>
            ),
            value: 'sentiment',
          },
          {
            text: (
              <BubbleCommon
                showIcon={false}
                tipsMap={summaryTopicSentimentTips}
              >
                {formatMessage({ id: 'Topic Sentiment' })}
              </BubbleCommon>
            ),
            value: 'sub_topic',
          },
        ]}
      />
    </div>
  );
}
